<template>
  <div class="HotPage">
    <Hot
      v-if="sonInfo"
      :info="sonInfo"
      :hotIdOrName="hotIdOrName"
      :isOne="true"
      @hotClose="() => {}"
    />
  </div>
</template>

<script>
import Hot from "../components/Hot.vue";
export default {
  components: { Hot },
  data() {
    return {
      sonInfo: null,
      hotIdOrName: null,
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 热点数据处理得到单个数据
    hotListFu(data) {
      // console.log(123,data.length);

      // data.forEach(v=>{

      //   console.log(`sid:${v.sid},title:${v.title}`);
      // })

      let info = data.find((v) => v.sid === this.$route.params.id);
      this.openHotFu(info, data);
    },

    // 封装点击热点的函数
    openHotFu(data, arr) {
      let temp = [];

      // 额外多出来的 不在场景热点列表中的热点
      const waiArr = [
        {
          name: "赵良璋",
          id: "ZLZ",
          info:{
            audio:[],
            image:[],
            link:[
              {
                content:'<p>民国时期赵良璋烈士穿过的皮夹克</p>',
                media:{
                  link:[{src:'http://yhtjyk.travel-yuhuatai.com:9888/YHTLSJNG/Model2.html?m=yht50'}]
                }
              }
            ],
            video:[]
          }
        },
        {
          name: "谢士炎",
          id: "XSY",
          info:{
            audio:[],
            image:[],
            link:[],
            video:[]
          }
        },
        {
          name: "周镐",
          id: "ZG",
          info:{
            audio:[],
            image:[],
            link:[],
            video:[]
          }
        },
      ];
      let waiObj = waiArr.find((v) => v.id === this.$route.params.id);

      if (waiObj) {
        this.hotIdOrName = {
          id: waiObj.id,
          name: waiObj.name,
        };
        this.sonInfo = waiObj.info
      } else {
        // 如果是多个热点合并
        if (data.title.split("&")[1]) {
          arr.forEach((v) => {
            if (v.title.split("&")[1] === data.title.split("&")[1]) {
              temp.push(v);
              if (v.media && v.media.image && v.media.image.length > 1) {
                v.media.image.forEach((p, pI) => {
                  if (pI !== 0) temp.push({ ...v, media: { image: [p] } });
                });
              }
            }
          });
          let obj = {
            image: [],
            audio: [],
            link: [],
            video: [],
          };
          temp.forEach((v) => {
            if (obj[v.type]) obj[v.type].push(v);
          });
          for (const k in obj) {
            if (k === "audio") {
              obj[k].reverse();
            }
          }

          this.hotIdOrName = {
            id: data.sid,
            name: data.title.split("&")[0],
          };
          this.sonInfo = obj;
        } else {
          this.hotIdOrName = {
            id: data.sid,
            name: data.title,
          };
          // 单个热点
          this.sonInfo = { [data.type]: [data] };
        }
      }
    },
  },
  created() {


  // 电脑端路径：
    // http://yhtjyk.travel-yuhuatai.com:9888/YHT/Swkk/index.html#/hotPage/1/ZG

    // 移动端路径
    // http://yhtjyk.travel-yuhuatai.com:9888/YHTM/index.html#/hotPage/1/ZG

    // 移动端和pc端的切换 
    // if (
    //   window.navigator.userAgent.match(
    //     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    //   )
    // ) {
    //   // 移动端
    //   window.location.href = window.location.href.replace("YHT/Swkk", "YHTM");
    //   location.reload();
    // }

    let lId = this.$route.params.key;
    window.KKNum = lId === "1" ? "KJ-aigSkgvRWR" : "KJ-ufjLwlSXba";
    const url = `http://yhtjyk.travel-yuhuatai.com:9888/YHT/Swkk/scene_view_data/${
      lId === "1" ? "KJ-aigSkgvRWR" : "KJ-ufjLwlSXba"
    }/user/hot.json`;
    fetch(url)
      .then((response) => response.json()) // 将响应转换为 JSON
      .then((data) => this.hotListFu(data)); // 处理数据
  },
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
.HotPage {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
</style>
